import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private apiUrl = environment.BASE_URL;
  // private filesUrl = environment.BASE_URL_FILES;
  constructor(private http: HttpClient) { }

  // Service to add image to the document container
  uploadImage(businessId: string, documentContainerId: string, fileName: string, data: any, mimeType: string): Observable<any> {
    const url = `${this.apiUrl}/upload-image`;
    const headers = { 'Content-Type': 'application/json', 'x-business-id': businessId };

    fileName = `${documentContainerId}.webp`;

    const body = { 
      fileName, 
      data,
      mimeType
    };
    return this.http.post(url, body, { headers });
  }

  // Service to add file to the document
  uploadFile(businessId: string, documentContainerId: string, documentId: string, fileName: string, data: any, mimeType: string): Observable<any> {
    const url = `${this.apiUrl}/upload-file`;
    const headers = { 'Content-Type': 'application/json', 'x-business-id': businessId };

    const body = { 
      fileName, 
      documentContainerId,
      documentId,
      data,
      mimeType
    };
    return this.http.post(url, body, { headers });
  }

  uploadCsvFile(businessId: string, fileName: string, data: any, mimeType: string): Observable<any> {
    const url = `${this.apiUrl}/upload-csv-file`;
    const headers = { 'Content-Type': 'application/json', 'x-business-id': businessId };

    const body = { 
      fileName, 
      data,
      mimeType
    };
    return this.http.post(url, body, { headers });
  }

  // getEmployeeImage(businessId: string, documentContainerId: string) {

  //   const fileName = `${businessId}_${documentContainerId}.webp`;

  //   return `${this.filesUrl}/images/${fileName}`;
  // }
}
